
const ElevatedPersonalShoppingSection = () => {
  return (
    <section
      style={{ backgroundColor: '#F7F8FA' }}
    >
      <div
        style={{
          backgroundColor: '#F7F8FA'
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0',
            width: '100%',
            margin: '0'
          }}
        >
          {/* Content Column - First */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '80px'
            }}
          >
            <div style={{ width: '100%' }}>
              <h2
                style={{
                  fontFamily: 'Cardo, serif',
                  fontSize: '40px',
                  color: '#111',
                  fontWeight: '400',
                  marginBottom: '32px',
                  lineHeight: '1.2'
                }}
              >
                Elevated Personal Shopping
              </h2>
              <div
                style={{
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  fontSize: '16px',
                  lineHeight: '1.6',
                  color: '#7B7B7B'
                }}
              >
                <p style={{ marginBottom: '24px' }}>
                  Our service goes far beyond traditional shopping assistance. Each client is 
                  paired with a personal shopper who understands not only personal taste, 
                  but also curates opportunities through our close relationships with global 
                  luxury brands, boutique ateliers, private dealers, and specialist experts.
                </p>
                <p>
                  Whether sourcing a rare handbag, a bespoke timepiece, or the season's 
                  most desirable object, we make the unattainable possible, always in the 
                  strictest confidence.
                </p>
              </div>
            </div>
          </div>

          {/* Image Column - Second */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%'
            }}
          >
            <img
              src="/Bespoke Shopping/Elevated Personal Shopping.png"
              alt="Elevated Personal Shopping - Luxury shopping experience"
              style={{
                width: '100%',
                height: 'auto',
                minHeight: '560px',
                objectFit: 'cover',
                borderRadius: '0'
              }}
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        @media (max-width: 1199px) {
          div[style*="grid-template-columns"] {
            grid-template-columns: 1fr !important;
            gap: 0 !important;
          }
          
          div[style*="padding: 80px"] {
            order: 2;
            padding: 40px !important;
          }
          
          div[style*="align-items: center"] {
            order: 1;
          }
        }

        @media (max-width: 899px) {
          section img {
            min-height: 300px !important;
          }
        }

        @media (min-width: 1200px) {
          div[style*="grid-template-columns"] {
            grid-template-columns: 1fr 1fr !important;
          }
        }
      `}</style>
    </section>
  )
}

export default ElevatedPersonalShoppingSection